import {
  GetCashflowSeriesProps,
  GetGroupedTransactionsProps,
  GetTransactionsProps,
  GetTransactionsTotalsProps,
} from "../pages/Transactions";
import { TransactionType } from "../utils";

export const buildQueryParams = (
  baseQuery: string,
  params:
    | GetTransactionsProps
    | GetTransactionsTotalsProps
    | GetGroupedTransactionsProps
    | GetCashflowSeriesProps,
): string => {
  let queryParams = baseQuery;

  if ("type" in params && !params.type.includes(TransactionType.ALL)) {
    params.type.forEach((t) => {
      queryParams += `&transactionType=${encodeURIComponent(t)}`;
    });
  }

  if ("groupBy" in params && params.groupBy) {
    queryParams += `&groupBy=${encodeURIComponent(params.groupBy)}`;
  }

  if ("bucket" in params && params.bucket) {
    queryParams += `&bucket=${encodeURIComponent(params.bucket)}`;
  }

  if ("from" in params && params.from) {
    queryParams += `&from=${encodeURIComponent(params.from)}`;
  }

  if ("to" in params && params.to) {
    queryParams += `&to=${encodeURIComponent(params.to)}`;
  }

  if (params.searchBy) {
    queryParams += `&searchBy=${encodeURIComponent(params.searchBy)}`;
  }

  if (params.accountId !== undefined && params.accountId !== null) {
    queryParams += `&accountId=${encodeURIComponent(params.accountId)}`;
  }

  if ("cashbackBuysOf" in params && params.cashbackBuysOf !== undefined) {
    queryParams += `&cashbackBuysOf=${encodeURIComponent(params.cashbackBuysOf)}`;
  }

  if ("year" in params && params.year !== undefined && params.year !== null) {
    queryParams += `&year=${encodeURIComponent(params.year)}`;
  }

  if (
    "month" in params &&
    params.month !== undefined &&
    params.month !== null
  ) {
    queryParams += `&month=${encodeURIComponent(params.month)}`;
  }

  if (params.categoryId) {
    queryParams += `&categoryId=${encodeURIComponent(params.categoryId)}`;
  }

  if ("dateRange" in params && params.dateRange) {
    queryParams += `&dateRange=${encodeURIComponent(params.dateRange)}`;
  }

  if (
    "limit" in params &&
    params.limit !== undefined &&
    params.limit !== null
  ) {
    queryParams += `&limit=${encodeURIComponent(params.limit)}`;
  }

  if (
    "specificYear" in params &&
    params.specificYear !== undefined &&
    params.specificYear !== null
  ) {
    queryParams += `&specificYear=${encodeURIComponent(params.specificYear)}`;
  }

  if (queryParams.startsWith("&")) {
    queryParams = "?" + queryParams.slice(1);
  }

  return queryParams;
};
